import React, { useState, useEffect, useContext } from "react";
import SeccionIzquierda from "./seccionIzquierda";
import Loader from "../../Global/Loader";
import {
  convertirParamAHabitaciones,
  crearPasajerosDefault,
  manejadorDeRespuesta,
  totalPasajeros,
} from "../../../utils/Tools";
import { ToastContainer } from "react-toastify";
import Breadcrumbs from "../../Resultados/breadcrumbs";
import Titulo from "../../Resultados/titulo";
import { CdrGlobalContext } from "../../../context/cdrGlobalContext";
import { cdrAPI } from "../../../utils/funcionesAPI";
import ProductoCuadro from "./ProductoCuadro";
import { UPDATE_BUSCADOR_HOTELES_Y_PASAJEROS } from "../../../context/constantes";

const ResultadosCdr = (props) => {
  const [state, dispatch] = useContext(CdrGlobalContext);
  const { provinciasParaHoteles = [] } = state || {};
  const [productosEncontrados, setProductosEncontrados] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const { destino, fechaIn, fechaOut, pasajeros } = props.match.params;
  const habitaciones = convertirParamAHabitaciones(pasajeros);
  const { totalAdultos, totalMenores } = totalPasajeros(habitaciones);
  const pasajerosAdultos = crearPasajerosDefault(totalAdultos, "Adulto");
  const pasajerosMenores = crearPasajerosDefault(totalMenores, "Menor");

  const setearBusqueda = () => {
    dispatch({
      type: UPDATE_BUSCADOR_HOTELES_Y_PASAJEROS,
      payload: {
        destino: destino,
        fechaIn,
        fechaOut,
        habitaciones,
        pasajerosAdultos,
        pasajerosMenores,
      },
    });
  };

  //destino=HAV&fecha-desde=2021-05-24&fecha-hasta=2021-05-24&pasajeros=2,1-3-2,2-8
  const traerHotelesBuscados = (destino, fechaIn, fechaOut, pasajeros) => {
    const data = JSON.stringify({
      peticion: "traerResultadosDeBusqueda",
      destino,
      fechaIn,
      fechaOut,
      habitaciones: convertirParamAHabitaciones(pasajeros),
    });
    setLoaded(false);
    cdrAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setLoaded(true);
        setProductosEncontrados(respuesta.data);
      }
    });
  };

  useEffect(() => {
    if (!destino || !fechaIn || !fechaOut || !pasajeros) {
      setLoaded(true);
      return;
    } else {
      setearBusqueda();
      traerHotelesBuscados(destino, fechaIn, fechaOut, pasajeros);
    }
    
  }, [destino, fechaIn, fechaOut, pasajeros]);

  const mostrarNombreDestino = (codigo) => {
    const destino =
      provinciasParaHoteles.find((prov) => prov.codigo === codigo) || {};

    return destino.denominacion || "Destino";
  };

  const handleCombinacionDeCamaClick = (idProducto, idHabitacion, idCombinacionCama) => {
    const indexProducto = productosEncontrados.findIndex(prod => prod.idProducto === idProducto);
    if (indexProducto === -1) return;
    const producto = {...productosEncontrados[indexProducto] };
    const indexHabitacion = producto.habitaciones.findIndex(hab => hab.idHabitacion === idHabitacion);
    if (indexHabitacion === -1) return;
    const habitacion = {...producto.habitaciones[indexHabitacion]};
    habitacion.idCombinacionCama = idCombinacionCama;
    producto.habitaciones[indexHabitacion] = habitacion;
    const newProdEncontrados = [...productosEncontrados];
    newProdEncontrados[indexProducto] = producto;
    setProductosEncontrados(newProdEncontrados);
  };

  const handleRegimenSeleccionado = (idProducto, idHabitacion, regimenSeleccionado) => {
    const indexProducto = productosEncontrados.findIndex(prod => prod.idProducto === idProducto);
    if (indexProducto === -1) return;
    const producto = {...productosEncontrados[indexProducto] };
    const indexHabitacion = producto.habitaciones.findIndex(hab => hab.idHabitacion === idHabitacion);
    if (indexHabitacion === -1) return;
    const habitacion = {...producto.habitaciones[indexHabitacion]};
    habitacion.regimenSeleccionado = regimenSeleccionado;
    producto.habitaciones[indexHabitacion] = habitacion;
    const newProdEncontrados = [...productosEncontrados];
    newProdEncontrados[indexProducto] = producto;
    setProductosEncontrados(newProdEncontrados);
  };

  return (
    <section id="main-content" className="main">
      <div className="container-fluid">
        <Breadcrumbs
          nombreDestino={mostrarNombreDestino(destino)}
          destino={destino}
          isCdr
        />
        <Titulo
          nombreDestino={mostrarNombreDestino(destino)}
          destino={destino}
          cantidadProductos={productosEncontrados.length}
          fechaIn={fechaIn}
          fechaOut={fechaOut}
          isCdr
        />

        <div className="row">
          <SeccionIzquierda />
          <article className="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-12 show-results">
            <Loader
              loaded={loaded}
              mensaje="Buscando Hoteles, aguarde unos instantes..."
            />
            {productosEncontrados.length === 0 && loaded && (
              <div className="loader row result">
                <h3>
                  No se han encontrado Hoteles en este rango de fechas. Por favor pruebe
                  buscando en otro periodo o con otro tipo de habitación.
                </h3>
              </div>
            )}
            {loaded && (
              <div>
                {productosEncontrados.map((producto) => {
                  return (
                    <ProductoCuadro
                      key={producto.idProducto}
                      producto={producto}
                      onCombinacionDeCamaClick={handleCombinacionDeCamaClick}
                      onRegimenSeleccionadoClick={handleRegimenSeleccionado}
                      cantidadHabitacionesSolicitadas={habitaciones.length}
                    />
                  );
                })}
              </div>
            )}
          </article>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default ResultadosCdr;

ResultadosCdr.propTypes = {};



// WEBPACK FOOTER //
// ./src/components/Hoteles/ResultadosCdr/index.js